var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import React from 'react';
import './index.less';
export default class Field extends React.Component {
    render() {
        const _a = this.props, { label, value } = _a, rest = __rest(_a, ["label", "value"]);
        return (React.createElement("div", Object.assign({ className: "field" }, rest),
            React.createElement("span", null, label),
            React.createElement("span", null, value)));
    }
}
